import React from "react";

interface FormErrorProps {
  text: string;
}

const FormError: React.FC<FormErrorProps> = ({ text }) => {
  return (
    <div className="form-error-message">
      {/* Replace with your own error icon if you have one in assets */}
      <span className="form-error-message__icon">!</span>
      <p className="form-error-message__text">{text}</p>
    </div>
  );
};

export default FormError;
